module.exports = __webpack_public_path__ + "img/history-ten.64977f16.png";